<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
    <li class="breadcrumb-item"><router-link to="/solutions/overview">Solutions</router-link></li>
    <li class="breadcrumb-item active" aria-current="page">Overview</li>
  </ol>
</nav>

<div class="row">

<div class="col-lg-8">
<h2 class="title">Solutions Overview</h2>

                <p class="lead">
                  Universal Tech LLC actively operates in the IT and data center
                  industry, providing products and services as with any other
                  player in the market sphere with a differentiating touch and
                  uniqueness. We treat every client fairly and respectfully and
                  address their needs quickly and effectively while staying true
                  to our ethical principles. We constantly keep pace with the
                  evolving business landscape; this guides us to apply an
                  equitable balance between business growth and sustainability
                  in our operations, inspiring us to always hit the mark of
                  excellence, as to how it should be, consistently.
                </p>

                <p class="lead">
                  Building a heritage for future generations, acting with an
                  owner mentality, developing people everywhere we are, and
                  meeting our commitments to all internal and external
                  stakeholders is the foundational value of Universal Tech LLC.
                </p>

</div>

<div class="col-lg-4">
  <OverviewSideNav></OverviewSideNav>
</div>
</div>
        

        </div>
      </section>
    </div>
  </div>
</template>
<script>
import OverviewSideNav from "./OverviewSideNav";
export default {
  name: "overview",
  components : {
    OverviewSideNav
  }
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
